import { Component } from 'react'
import { StyledSubHeading } from 'components/headings'
import LinkCopier from '../../containers/link-copier'
import ShareByEmailModal from '../share-by-email-modal'
import Link from 'components/link'
import { settingsRegistryPath } from 'lib/urls'

class RegistryLinkSection extends Component {
  state = {
    showShareByEmailModal: false,
  }

  render() {
    return (
      <div>
        <StyledSubHeading>Registry Link</StyledSubHeading>
        <p>
          Make it easy for your showers guests to check out your baby registry
          by giving them a direct link to your registry.
        </p>
        <LinkCopier />
        <div className="mbl">
          <Link url={settingsRegistryPath} className="text-brand-info">
            Customize your registry link
          </Link>
        </div>
        <div className="mbl visible-xs-block" />
        <ShareByEmailModal
          onHide={this.handleHideShowShareByEmailModal.bind(this)}
          show={this.state.showShareByEmailModal}
        />
      </div>
    )
  }

  handleHideShowShareByEmailModal() {
    this.setState({ showShareByEmailModal: false })
  }

  handleShowShareByEmailModal() {
    this.setState({ showShareByEmailModal: true })
  }
}

export default RegistryLinkSection
